import React from "react"

import {
  Box,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Typography
} from "@mui/material"

import TimerHeader from "components/TimerTable/TimerHeader"
import TimerRow from "components/TimerTable/TimerRow"
import { useHuntTrackerContext } from "tracker-context";
import { SessionConfigs } from "sessions/sessionState";
import LanguageDependentText from "components/TimerTable/LanguageDependentText";
import FATEMainRow from "./FATEMainRow";

function huntNameSort(rows, order) {
  var rowArray = [];
  for (var j = 0; j < rows.length; j++) {
    rowArray[rowArray.length] = [rows[j].dataset.sortName.toLowerCase(), rows[j]];
  }
  rowArray.sort(function(a,b) {
    if (a[0]==b[0]) return 0;
    return a[0] < b[0] ? -order : order;
  });

  return rowArray;
}

function regionNameSort(rows, order) {
  var rowArray = [];
  for (var j = 0; j < rows.length; j++) {
    rowArray[rowArray.length] = [rows[j].dataset.sortRegion.toLowerCase(), rows[j]];
  }
  rowArray.sort(function(a,b) {
    if (a[0]==b[0]) return 0;
    return a[0] < b[0] ? -order : order;
  });
  
  return rowArray;
}

function maxTimeSort(rows, order) {
  var rowArray = [];
  for (var j = 0; j < rows.length; j++) {
    rowArray[rowArray.length] = [rows[j].dataset.sortMaxTime, rows[j]];
  }

  rowArray.sort(function(a,b) {
    if (a[0]==b[0]) return 0;
    return a[0] < b[0] ? -order : order;
  });

  return rowArray;
}

function defaultSort(rows) {
  var rowArray = [];
  for (var j = 0; j < rows.length; j++) {
    rowArray[rowArray.length] = [parseInt(rows[j].dataset.sortDefault), rows[j]];
  }

  rowArray.sort(function(a,b) {
    if (a[0]==b[0]) return 0;
    return a[0] < b[0] ? -1 : 1;
  });

  return rowArray;
}

const FATETable = ({name, bossFATEs, chainFATEs, audioRef, children}) => {
  const textLibrary = SessionConfigs.dictionaryLookup;
  
  var defaultHeaders = [
    {name: "tableHuntName", suffix:"", width: "40%", align: "left"},
    {name: "tableRegionName", suffix:"", width: "20%", align: "left"},
    {name: "tableTimer", suffix:"", width: "20%", align: "center"},
  ];

  return (
    <Table id={name} style={{padding: 0}}>
      <Box component="thead">
        <tr>
          {defaultHeaders.map((header) => (
            <TableCell key={header.name} align={header.align} style={{width: header.width, maxWidth: header.width, paddingBottom: "0px"}} >
              <Typography component="p" variant="button" sx={{ fontSize: 13, cursor: "pointer" }} fontWeight="medium">
                {textLibrary("header", header.name)}
              </Typography>
            </TableCell>
          ))}
        </tr>
      </Box>
      <TableBody>
        {bossFATEs.map((fate) => {
          const subFATEs = fate.Chained.map((chain) => chainFATEs[fate.worldName + "_" + chain]).filter((a) => a);
          return <FATEMainRow key={fate.worldName + "_" + fate.fateName} bossFATE={fate} subFATEs={subFATEs}/>
        })}
      </TableBody>
      
    </Table>
  );
};

export default FATETable;